module.exports = __webpack_public_path__ + "img/t5-gray.d80c32c1.png";